import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import { formatToDecimal } from '../../conversions';
import { formatToFractional } from '../../conversions';

const FrameWidth = ({ value, onChange, 
                      id = 'FrameWidth', label = 'Frame Width', doorSizeValue = null, doorHeightValue = null, passSelectedDoor,
    minValue, maxValue,
    disabled = false
 }) => {
    const [selectedFrameWidth, setSelectedFrameWidth] = useState(value || "40\"");
     const [FrameWidthError, setFrameWidthError] = useState("");



     const calcWidth = (doorType, doorSize) => {
        if (doorType === 1) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 1).toString() + ' 1/2"';
        }
        if ([2, 3].includes(doorType)) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 17).toString() + '"';
        }
        if (doorType === 4) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) + 32).toString() + ' 1/2"';
        }
        if (doorType === 5) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 2).toString() + '"';
        }
        if ([6, 7].includes(doorType)) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 17).toString() + ' 1/2"';
        }
        if (doorType === 8) {
            let width = doorSize.replace('"', '');
            return (parseInt(width) * 2 + 2*17 - 1).toString() + '"';
        }
        return 0;
     }
/*    useEffect(() => {
        if (passSelectedDoor) {
                //validateFrameWidth(selectedFrameWidth, minValue, maxValue);
        }
      }, [passSelectedDoor, value, minValue, maxValue]); // Trigger effect whenever doorSizeValue changes
*/
      useEffect(() => {
        // Re-validate the current input whenever min/max values change
        if (selectedFrameWidth && minValue && maxValue) {
          validateFrameWidth(selectedFrameWidth);
        }
      }, [minValue, maxValue]);

      // Follow value changes made by the parent (e.g. typed in a linked mm field)
      useEffect(() => {
        if (value !== undefined && value !== selectedFrameWidth) {
          setSelectedFrameWidth(value);
          validateFrameWidth(value);
        }
      }, [value]);
      

    const handleFrameWidthChange = (e) => {
        setSelectedFrameWidth(e.target.value);
        validateFrameWidth(e.target.value);
        onChange(e.target.value);
    };
 
    const validateFrameWidth = (val) => {
        const numericValue = formatToDecimal(val);
        if (numericValue && (numericValue < minValue || numericValue > maxValue)) {
          setFrameWidthError(`Width must be between ${minValue} and ${maxValue}`);
        } else {
          setFrameWidthError('');
        }
      };

        
    const handleFocus = (e) => {
      let decimalValue = formatToDecimal(e.target.value);
      if (decimalValue === 0) decimalValue = "";
      setSelectedFrameWidth(decimalValue);
    };

    const handleBlur = (e) => {
      const fractionalValue = formatToFractional(e.target.value);
      setSelectedFrameWidth(fractionalValue);
      onChange(fractionalValue);
    };

    return (
        <div className="a-container">
            <label disabled={disabled} htmlFor={id}>{label}</label>
            <input
                disabled={disabled}
                id={id}
                value={selectedFrameWidth}
                onChange={handleFrameWidthChange}
                onFocus={handleFocus}
                onBlur={handleBlur}
            >
            </input>
            {FrameWidthError && <p className="error">{FrameWidthError}</p>}
        </div>
    );
};

export default FrameWidth;